module.exports = __webpack_public_path__ + "img/haiKeSi.16c12402.png";